/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";
import { Button } from "rsuite";
import { Trash } from "@rsuite/icons";
import RemoveUserModal from "./RemoveUserModal";

interface Props {
    walletKey: string;
    bucketId: string | undefined;
    handleModalClose: () => void;
}

const RemoveUserButton = ({ walletKey, bucketId, handleModalClose }: Props) => {
    // const [addTag, setAddTag] = useState(false); // Updated state name

    const [open, setOpen] = useState(false);
    const [props, setProps] = useState<any | null>(null);
    // const [logData, setLogData] = useState<any[]>([]);

    const handleClose = () => {
        setOpen(false);
        handleModalClose();
    };

    useEffect(() => {
        // get the accountReference of the selectedRows
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const sub = {
            walletKey,
            bucketId,
        };
        setProps(sub);
    }, [walletKey]);

    return (
        <>
            <Button
                appearance="primary"
                className="bg-red-700 py-2 px-4 text-white w-fit hover:bg-red-600 rounded"
                onClick={() => {
                    setOpen(true);
                }}
            >
                <Trash className="mx-2" />
                Remove User from Bucket
            </Button>

            <RemoveUserModal
                open={open}
                props={props}
                handleClose={() => setOpen(false)}
                handleComplete={handleClose}
            />
        </>
    );
};

export default RemoveUserButton;
